// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/tension-spring/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const tensionSpringEN: PageEntry = {
  id: "post.spannfeder",
  locale: "en",
  slug: "tension-spring",
  seo: {
    title: "Glossary: Tension spring explained simply | Dietz GmbH",
    description: "Tension springs are springs that are used to tighten or tension components or elements. These springs are often used in combination with other mechanisms to create a mechanical pre",
  },
  type: "post",
  h1: "Glossary: Tension spring explained simply",
  intro: "Tension springs are springs that are used to tighten or tension components or elements. These springs are often used in combination with other mechanisms to create a mechanical preload. Tension springs are used in a variety of applications, from industrial machinery to tools and fixtures. Due to their ability to absorb and transmit tensile forces, tension springs help to ensure the stability of assemblies. When selecting tension springs, factors such as spring constant, choice of material and geometric properties are decisive.",
  blocks: [

  ],
};
